import React from 'react';

import { Container, Label, Value } from './styles';

const CardCountSeller = ({ value }) => {
	return (
		<Container>
			<Label>Vendedores</Label>
			<Value>{value}</Value>
		</Container>
	);
};

export default CardCountSeller;
